// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__16JXe","cell":"ColumnAccessor_cell__207LE","firstCellAccent":"ColumnAccessor_firstCellAccent__3Wnj6"};